CopyClauses = {
  init: function(form, selectAtLeastOneMessage) {
    this.form = form;
    this.selectAtLeastOneMessage = selectAtLeastOneMessage;
    this.bindSelectAll();
    this.bindFormValidation();
  },

  bindSelectAll: function() {
    var selectAll = document.getElementById('js-select-all-clauses');
    if (!selectAll) return;

    selectAll.addEventListener('change', function() {
      var checkboxes = document.querySelectorAll('.js-clause-checkbox');
      checkboxes.forEach(function(checkbox) {
        checkbox.checked = selectAll.checked;
      });
    });

    // Sync select-all when individual checkboxes change
    var checkboxes = document.querySelectorAll('.js-clause-checkbox');
    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        var allChecked = document.querySelectorAll('.js-clause-checkbox').length ===
                         document.querySelectorAll('.js-clause-checkbox:checked').length;
        selectAll.checked = allChecked;
      });
    });
  },

  bindFormValidation: function() {
    var self = this;
    this.form.addEventListener('submit', function(event) {
      var checked = document.querySelectorAll('.js-clause-checkbox:checked');
      if (checked.length === 0) {
        event.preventDefault();
        alert(self.selectAtLeastOneMessage);
      }
    });
  }
};
